import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import {
  ContractError,
  HttpError,
  ok,
  Result,
  UnknownError,
} from "@nju/result";
import { ICountryResponse } from "./types";
import { identityCountries, roamingInternationalCountries } from "./validators";

const modeToOrchestratorMap = {
  ROAMING: roamingInternationalCountries,
  INTERNATIONAL: roamingInternationalCountries,
  IDENTITY: identityCountries,
} as const;

type IBrandProps = "NJU";

interface IFetchCountriesProps<T> {
  brand?: IBrandProps;
  category: T;
}

export async function fetchCountries<T extends keyof ICountryResponse>({
  brand,
  category,
}: IFetchCountriesProps<T>): Promise<
  Result<ContractError | HttpError | UnknownError, ICountryResponse[T]>
> {
  const serverResponse = modeToOrchestratorMap[category];
  const result = await client<ICountryResponse[T]>(
    `${process.env.NEXT_PUBLIC_ANONYMOUS_GATEWAY_HOST}/cms/countries`,
    {
      validator: serverResponse,
      searchParams: {
        ...(brand && { brand }),
        ...(category === "IDENTITY"
          ? { ISO_3166_1_alpha_3_null: false }
          : { category }),
      },
    },
  );

  if (result.isError) {
    Bugsnag.notify(result.err);
    return result;
  }

  const sortedCountries = result.value.sort((a, b) => {
    return a.displayName.pl.localeCompare(b.displayName.pl);
  });

  return ok(sortedCountries as ICountryResponse[T]);
}
